import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.3)]"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-950 no-underline shrink-0"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-movie-2-line text-lg text-white"></i>
          </div>
          <span className="text-xl font-heading font-bold tracking-wide whitespace-nowrap">
            大师兄影视
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.id === "all" ? "/category" : `/category?type=${cat.id}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer no-underline ${
                (cat.id === "all" && location.pathname === "/category" && !location.search) ||
                (cat.id !== "all" && location.search.includes(`type=${cat.id}`))
                  ? "bg-primary-500 text-white"
                  : scrolled
                    ? "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                    : "text-foreground-800 hover:bg-white/10 hover:text-foreground-950"
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer no-underline"
          >
            关于我们
          </Link>
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 cursor-pointer hover:bg-background-300 transition-colors">
            <i className="ri-search-line text-foreground-700 text-sm"></i>
          </div>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer bg-background-200"
          aria-label="菜单"
        >
          <i className={`text-lg text-foreground-700 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200 px-4 py-4">
          <div className="flex flex-wrap gap-2 mb-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={cat.id === "all" ? "/category" : `/category?type=${cat.id}`}
                className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap cursor-pointer no-underline ${
                  (cat.id === "all" && location.pathname === "/category" && !location.search) ||
                  (cat.id !== "all" && location.search.includes(`type=${cat.id}`))
                    ? "bg-primary-500 text-white"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className="block w-full text-center py-2 rounded-lg text-sm text-foreground-700 bg-background-200 hover:bg-background-300 transition-colors cursor-pointer no-underline"
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}